/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import NHH from '/public/static/nhh.png';
import Survey from '/public/static/student_survey_results.png';
import Image from 'next/image';
export const meta = {
  author: 'Jens Aarre Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  meta: meta,
  title: "Students` response to Curipod at Norwegian School of Economics (NHH)",
  subTitle: "Find out what sudents really think about using Curipod",
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      strong: "strong",
      a: "a",
      h3: "h3"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(Image, {
        src: NHH
      }), "\n", _jsx(_components.p, {
        children: "Curipod was rolled out to 400 first year students at NHH in the spring 2021. A survey was sent out to the students at the end of the semester by NHH where the students responded as shown below."
      }), "\n", _jsx(Image, {
        src: Survey
      }), "\n", _jsx(_components.p, {
        children: "Sample from survey sent out to NHH students (n = 62 respondents) and answer percentage (ca. 6.7%, N = 930 invited)"
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.strong, {
          children: _jsx(_components.a, {
            href: "https://www.nhh.no/en/nhh-bulletin/article-archive/2021/october/thousands-are-using-the-curipod-platform/",
            children: "Read more about the experience from NHH at their website here"
          })
        })
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "About NHH Norwegian School of Economics"
        })
      }), "\n", _jsx(_components.p, {
        children: "The Norwegian School of Economics (NHH) is a business school situated in Bergen, Norway. It was founded in 1936 as Norway's first business school and has since its establishment been a leading teaching and research institution in the fields of economics and business administration"
      }), "\n", _jsx(_components.p, {
        children: "Admission to NHH is the most selective in the field of business administration in Norway and among the most selective of all study programs offered in Norway."
      })]
    });
  }
}
export default MDXContent;
